/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const iconArrowDown = () => (
  <svg
    width="9"
    height="7"
    viewBox="0 0 9 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.7466 6.14407C4.62729 6.31627 4.37271 6.31627 4.2534 6.14407L0.9291 1.34585C0.791255 1.14689 0.933652 0.874999 1.1757 0.874999L7.8243 0.875C8.06635 0.875 8.20875 1.14689 8.0709 1.34585L4.7466 6.14407Z"
      fill="#E37879"
    />
  </svg>
)

const ArrowDownIcon = (props) => <Icon component={iconArrowDown} {...props} />

export { ArrowDownIcon }
